import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
    AdaptedSelect,
    DropzoneControl,
    InputControl,
    Optional
} from "../components/Form";
import { Loader } from "../components/Loader";
import { LanguageCode, Media, useLanguagesQuery } from "../graphql";

export interface ICreateStoryItemFormValues {
  linkLabel: string;
  linkURL: string;
  bgColor: string;
  storyId: number;
  media: Media;
  isActive: "0" | "1";
  languageCode: LanguageCode;
}

interface IStoryItemForm {
  onSubmit: (values: ICreateStoryItemFormValues) => void;
  initialValues?: Optional<ICreateStoryItemFormValues>;
}

export const StoryItemForm: React.FC<IStoryItemForm> = ({
    onSubmit,
    initialValues
}) => {
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (!values.media?.key) {
            errors.media = "Fushë e detyruar";
        }
        if (!values.languageCode) {
            errors.languageCode = "Fushë e detyruar";
        }

        return errors;
    };

    const { loading, data } = useLanguagesQuery({});
    const languages = data?.languages;

    if (loading) {
        return <Loader></Loader>;
    }

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                    <Field name="languageCode" component={ AdaptedSelect } label="Gjuha">
                        { languages.map((item) => (
                            <option value={ item.code }>{ item.name }</option>
                        )) }
                    </Field>
                    <InputControl type="text" name="linkLabel" label="Përshkrimi" />
                    <InputControl type="text" name="linkURL" label="Adresa URL" />
                    <InputControl type="color" name="bgColor" label="Sfondi" />
                    <DropzoneControl name="media" label="Media" />
                    <Field name="isActive" component={ AdaptedSelect } label="Aktive">
                        <option value="1">Po</option>
                        <option value="0">Jo</option>
                    </Field>

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Ruaj
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
